import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const updateGroupTopic = (data) => {
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.ORGANIZE.UPDATE_GROUP_TOPIC,
    data
  );
};

export default updateGroupTopic;
